"use strict"

export const DEFAULT_RUBRIC_ID = "default"
export const DEFAULT_MAX_SCORE = 5
export const DEFAULT_HIGH_SCORE_THRESHOLD = 4

export const resolveAvailableRubricId = ({
  rubrics = [],
  preferredRubricIds = [],
  fallbackRubricId = DEFAULT_RUBRIC_ID,
}) => {
  const rubricIds = rubrics.map((rubric) => rubric?.id).filter(Boolean)
  if(rubricIds.length === 0) return fallbackRubricId

  for(const rubricId of preferredRubricIds) {
    if(rubricId && rubricIds.includes(rubricId)) return rubricId
  }
  if(rubricIds.includes(DEFAULT_RUBRIC_ID)) return DEFAULT_RUBRIC_ID
  return rubricIds[0] || fallbackRubricId
}
